import { render, staticRenderFns } from "./SDSFileUpload.vue?vue&type=template&id=88a9f0b6&scoped=true"
import script from "./SDSFileUpload.vue?vue&type=script&lang=js"
export * from "./SDSFileUpload.vue?vue&type=script&lang=js"
import style0 from "./SDSFileUpload.vue?vue&type=style&index=0&id=88a9f0b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a9f0b6",
  null
  
)

export default component.exports